import $http from './http'
import config from './config'

export default {
  name: 'trainpolicy',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getTrainLists(data) {
    return $http.post(this.getUrl(`/TrainSearch/Search`), data);
  },
  getStationList(data) {
    return $http.post(this.getUrl(`/TrainSearch/Station`), data);
  },
  getProductInfo(data) {
    return $http.post(this.getUrl(`/TrainPolicy/ProductInfo`), data);
  },
}



// WEBPACK FOOTER //
// ./src/apis/trainPolicyApi.js